import { createFileRoute } from '@tanstack/react-router';

import { WCzasieView } from '../../raporty/projekty/WCzasieView';

export const Route = createFileRoute('/raporty/projekty-w-czasie')({
  component: WCzasieView,
});
